let debounce = require('../../modules/debounce');
require('./tiles.less');

let size = require('../../modules/size');

jQuery(function() {
    function tileLayoutChanged($this, oldWidth, newWidth) {
        oldWidth = parseInt(oldWidth);
        newWidth = parseInt(newWidth);

        var arEdges = [size.desktop, size.tabletBig, size.tablet];

        var paddingCorrection = 0;

        var $wrapper = $this.closest('.wrapper');
        paddingCorrection += parseInt($wrapper.css('padding-left'));
        paddingCorrection += parseInt($wrapper.css('padding-right'));
        paddingCorrection = parseInt(paddingCorrection);
        for (var key in arEdges) {
            var cur = arEdges[key];
            cur = parseInt(cur);

            var diffOld = oldWidth + paddingCorrection - cur;
            var diffNew = newWidth + paddingCorrection - cur;

            //если изменение ширины блока перешагнуло через одну из границ
            if (Math.max(diffOld, diffNew) > 0 && Math.min(diffOld, diffNew) < 0) {
                return true;
            }
        }
        return false;
    }

    function findTileWithNeededWIdth($tiles, index, leftSpace) {
        var $return = 0;

        $tiles.each(function(ind) {
            if (ind <= index) return true;

            var $cur = $(this);

            if (!$cur.is(':visible')) return true;

            if (leftSpace >= parseInt($cur.innerWidth())) {
                $return = $cur;
                return false;
            }
        });

        return $return;
    }

    function reflowTiles() {
        $('.js-tiles-container').each(function() {
            var $this = $(this);
            var $tiles = $this.find('.tiles_item');
            var totalWidth = $this.width();

            var oldWidth = $this.attr('old-width');
            if (isNaN(oldWidth)) oldWidth = 0;

            if (oldWidth == totalWidth) {
                return true;
            }

            if (!tileLayoutChanged($this, oldWidth, totalWidth)) return true;

            $this.attr('old-width', totalWidth);

            var curLineWidth = 0;

            $tiles.each(function() {
                var $curTile = $(this);

                if (!$curTile.is(':visible')) return true;

                var curTileWidth = $curTile.innerWidth();

                if (curLineWidth + curTileWidth <= totalWidth) {
                    //влезает
                    curLineWidth += curTileWidth;

                    //новая строка
                    if (curLineWidth == totalWidth) curLineWidth = 0;
                } else {
                    //не влезает
                    var leftSpace = totalWidth - curTileWidth;
                    var $tileToChange = findTileWithNeededWIdth($tiles, $tiles.index($curTile), leftSpace);

                    if ($tileToChange == 0) return true;

                    $tileToChange.insertBefore($curTile);
                    return false;
                }
            });
        });
    }

    reflowTiles();
    debounce.setResizeDebounce(reflowTiles);
});



// WEBPACK FOOTER //
// ./blocks/tiles/tiles.js